import {
  animate,
  AnimationTriggerMetadata,
  style,
  transition,
  trigger,
} from '@angular/animations';

/**
 * Animations used by the product card.
 */
export const carouselAnimations: AnimationTriggerMetadata = trigger(
  'inOutAnimation',
  [
    transition(':enter', [
      style({ height: 0, opacity: 0 }),
      animate('0.5s ease-out', style({ height: 'auto', opacity: 1 })),
    ]),
    transition(':leave', [
      style({ height: 'auto', opacity: 1 }),
      animate('0.5s ease-in', style({ height: 0, opacity: 0 })),
    ]),
  ],
);
